import React from 'react';
import Modal, { ModalFooter, ModalHeader, ModalBody, Sheets } from '@ingka/modal';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums/lib';
import { useIntl } from 'react-intl';
import { useAppDispatch } from 'ducks/hooks';
import Body from 'ui/Typography/Body';
import Button from '@ingka/button';
import Title, { HeadingType } from 'ui/Typography/Title';
import '@ingka/svg-icon/dist/style.css';
import '@ingka/button/dist/style.css';
import '@ingka/modal/dist/style.css';
import '@ingka/svg-icon/dist/style.css';
import '@ingka/focus/dist/style.css';
import { useSelector } from 'react-redux';
import { useCore } from 'contexts/core';
import Box from 'ui/Box';
import CollisionImage from './collision-tv.jpg';
import styled from 'styled-components';
import { ProductType, RedOutlineComponent } from '@inter-ikea-storageone/range';
import { hideCollisionTVSheet, isTvCollisionSheetVisible } from '../TVFeature';

const Image = styled.img`
  width: 100%;
`;

function CollisionTVSheet() {
  const { formatMessage } = useIntl();
  const dispatch = useAppDispatch();
  const isVisible = useSelector(isTvCollisionSheetVisible);
  const coreApi = useCore();

  const onOkClicked = () => {
    const collidingFrames = coreApi.entities.getByComponent(RedOutlineComponent.id);
    collidingFrames.forEach(frame => frame.removeComponent(RedOutlineComponent.id));
    const tvIsInScene = coreApi.entities.getByProductTypes([
      ProductType.TV,
      ProductType.TV_WITH_FOOT
    ]);
    if (tvIsInScene.length > 0) {
      coreApi.entities.select(tvIsInScene[0]);
    }
    dispatch(hideCollisionTVSheet());
  };

  return (
    <Modal
      data-testid="collision-tv-sheet"
      visible={isVisible}
      escapable={true}
      handleCloseBtn={onOkClicked}
    >
      <Sheets
        title={formatMessage({ id: 'storageone.tvCollidingSheetTitle' })}
        header={
          <ModalHeader
            data-testid="modal-header"
            ariaCloseTxt={formatMessage({ id: 'storageone.closeButton' })}
          />
        }
        footer={
          <ModalFooter>
            <Button
              text={formatMessage({ id: 'storageone.removeIncludedShelfSheetButtonPrimary' })}
              onClick={onOkClicked}
              type="primary"
              data-testid="colliding-tv"
              fluid
            />
          </ModalFooter>
        }
      >
        <ModalBody>
          <Title
            mb="xl"
            type={ThemeFontStyleTypeEnum.headingMedium}
            heading={HeadingType.HeadingTwo}
          >
            {formatMessage({ id: 'storageone.tvCollidingSheetTitle' })}
          </Title>
          <Body type={ThemeFontStyleTypeEnum.bodyMedium}>
            {formatMessage({ id: 'storageone.tvCollidingSheetBody' })}
          </Body>
          <Box p={'xxxxxl'} style={{ width: '100%' }}>
            <Image src={CollisionImage} alt={'TV colliding with frame'} />
          </Box>
        </ModalBody>
      </Sheets>
    </Modal>
  );
}

export default CollisionTVSheet;
